import { Component, Input, OnInit } from '@angular/core';
import { ImgConstants } from '@core/constants/img-constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() pageName: string;
  @Input() noTitle: boolean;
  @Input() isAddBoxIcon: boolean;
  @Input() isUseSavedLocationIcon: boolean;
  @Input() isInfoIcon: boolean;
  @Input() headerIconName: string;

  constructor(public imgConstants: ImgConstants) {}

  public ngOnInit(): void {}
}
